export const CORE_LOAD_MASTER_DATA_WAREHOUSES_REQUEST = "CORE_LOAD_MASTER_DATA_WAREHOUSES_REQUEST"
export const CORE_LOAD_MASTER_DATA_WAREHOUSES_SUCCESS = "CORE_LOAD_MASTER_DATA_WAREHOUSES_SUCCESS"
export const CORE_LOAD_MASTER_DATA_WAREHOUSES_FAILURE = "CORE_LOAD_MASTER_DATA_WAREHOUSES_FAILURE"

export const CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST = "CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST"
export const CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS = "CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS"
export const CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE = "CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE"


export const CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_REQUEST = "CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_REQUEST"
export const CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_SUCCESS = "CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_SUCCESS"
export const CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_FAILURE = "CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_FAILURE"

export const CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_REQUEST = "CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_REQUEST"
export const CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_SUCCESS = "CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_SUCCESS"
export const CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_FAILURE = "CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_FAILURE"

export const CORE_CREATE_REQ_MASTER_REPORT_TYPE_REQUEST = "CORE_CREATE_REQ_MASTER_REPORT_TYPE_REQUEST"
export const CORE_CREATE_REQ_MASTER_REPORT_TYPE_SUCCESS = "CORE_CREATE_REQ_MASTER_REPORT_TYPE_SUCCESS"
export const CORE_CREATE_REQ_MASTER_REPORT_TYPE_FAILURE = "CORE_CREATE_REQ_MASTER_REPORT_TYPE_FAILURE"

export const CORE_UPDATE_REQ_MASTER_REPORT_TYPE_REQUEST = "CORE_UPDATE_REQ_MASTER_REPORT_TYPE_REQUEST"
export const CORE_UPDATE_REQ_MASTER_REPORT_TYPE_SUCCESS = "CORE_UPDATE_REQ_MASTER_REPORT_TYPE_SUCCESS"
export const CORE_UPDATE_REQ_MASTER_REPORT_TYPE_FAILURE = "CORE_UPDATE_REQ_MASTER_REPORT_TYPE_FAILURE"

export const CORE_DELETE_REQ_MASTER_REPORT_TYPE_REQUEST = "CORE_DELETE_REQ_MASTER_REPORT_TYPE_REQUEST"
export const CORE_DELETE_REQ_MASTER_REPORT_TYPE_SUCCESS = "CORE_DELETE_REQ_MASTER_REPORT_TYPE_SUCCESS"
export const CORE_DELETE_REQ_MASTER_REPORT_TYPE_FAILURE = "CORE_DELETE_REQ_MASTER_REPORT_TYPE_FAILURE"


export const CORE_GET_ALL_MASTER_HR_SALARY_REQUEST = "CORE_GET_ALL_MASTER_HR_SALARY_REQUEST"
export const CORE_GET_ALL_MASTER_HR_SALARY_SUCCESS = "CORE_GET_ALL_MASTER_HR_SALARY_SUCCESS"
export const CORE_GET_ALL_MASTER_HR_SALARY_FAILURE = "CORE_GET_ALL_MASTER_HR_SALARY_FAILURE"



export const CORE_GET_ALL_HR_SALARY_REQUEST = "CORE_GET_ALL_HR_SALARY_REQUEST"
export const CORE_GET_ALL_HR_SALARY_SUCCESS = "CORE_GET_ALL_HR_SALARY_SUCCESS"
export const CORE_GET_ALL_HR_SALARY_FAILURE = "CORE_GET_ALL_HR_SALARY_FAILURE"

export const CORE_GET_MASTER_HR_SALARY_BY_ID_REQUEST = "CORE_GET_MASTER_HR_SALARY_BY_ID_REQUEST"
export const CORE_GET_MASTER_HR_SALARY_BY_ID_SUCCESS = "CORE_GET_MASTER_HR_SALARY_BY_ID_SUCCESS"
export const CORE_GET_MASTER_HR_SALARY_BY_ID_FAILURE = "CORE_GET_MASTER_HR_SALARY_BY_ID_FAILURE"

export const CORE_CREATE_HR_SALARY_REQUEST = "CORE_CREATE_HR_SALARY_REQUEST"
export const CORE_CREATE_HR_SALARY_SUCCESS = "CORE_CREATE_HR_SALARY_SUCCESS"
export const CORE_CREATE_HR_SALARY_FAILURE = "CORE_CREATE_HR_SALARY_FAILURE"

export const CORE_UPDATE_HR_SALARY_REQUEST = "CORE_UPDATE_HR_SALARY_REQUEST"
export const CORE_UPDATE_HR_SALARY_SUCCESS = "CORE_UPDATE_HR_SALARY_SUCCESS"
export const CORE_UPDATE_HR_SALARY_FAILURE = "CORE_UPDATE_HR_SALARY_FAILURE"

export const CORE_CANCEL_HR_SALARY_REQUEST = "CORE_CANCEL_HR_SALARY_REQUEST"
export const CORE_CANCEL_HR_SALARY_SUCCESS = "CORE_CANCEL_HR_SALARY_SUCCESS"
export const CORE_CANCEL_HR_SALARY_FAILURE = "CORE_CANCEL_HR_SALARY_FAILURE"

export const CORE_ACKNOWLEDGE_HR_SALARY_REQUEST = "CORE_ACKNOWLEDGE_HR_SALARY_REQUEST"
export const CORE_ACKNOWLEDGE_HR_SALARY_SUCCESS = "CORE_ACKNOWLEDGE_HR_SALARY_SUCCESS"
export const CORE_ACKNOWLEDGE_HR_SALARY_FAILURE = "CORE_ACKNOWLEDGE_HR_SALARY_FAILURE"

export const CORE_ACCEPT_HR_SALARY_REQUEST = "CORE_ACCEPT_HR_SALARY_REQUEST"
export const CORE_ACCEPT_HR_SALARY_SUCCESS = "CORE_ACCEPT_HR_SALARY_SUCCESS"
export const CORE_ACCEPT_HR_SALARY_FAILURE = "CORE_ACCEPT_HR_SALARY_FAILURE"

export const CORE_REPORT_HR_SALARY_REQUEST = "CORE_REPORT_HR_SALARY_REQUEST"
export const CORE_REPORT_HR_SALARY_SUCCESS = "CORE_REPORT_HR_SALARY_SUCCESS"
export const CORE_REPORT_HR_SALARY_FAILURE = "CORE_REPORT_HR_SALARY_FAILURE"

export const CORE_REJECT_HR_SALARY_REQUEST = "CORE_REJECT_HR_SALARY_REQUEST"
export const CORE_REJECT_HR_SALARY_SUCCESS = "CORE_REJECT_HR_SALARY_SUCCESS"
export const CORE_REJECT_HR_SALARY_FAILURE = "CORE_REJECT_HR_SALARY_FAILURE"

export const CORE_COMPLETE_HR_SALARY_REQUEST = "CORE_COMPLETE_HR_SALARY_REQUEST"
export const CORE_COMPLETE_HR_SALARY_SUCCESS = "CORE_COMPLETE_HR_SALARY_SUCCESS"
export const CORE_COMPLETE_HR_SALARY_FAILURE = "CORE_COMPLETE_HR_SALARY_FAILURE"

export const CORE_GET_SETTING_HR_REQ_REQUEST = "CORE_GET_SETTING_HR_REQ_REQUEST"
export const CORE_GET_SETTING_HR_REQ_SUCCESS = "CORE_GET_SETTING_HR_REQ_SUCCESS"
export const CORE_GET_SETTING_HR_REQ_FAILURE = "CORE_GET_SETTING_HR_REQ_FAILURE"

export const CORE_UPDATE_SETTING_HR_REQ_REQUEST = "CORE_UPDATE_SETTING_HR_REQ_REQUEST"
export const CORE_UPDATE_SETTING_HR_REQ_SUCCESS = "CORE_UPDATE_SETTING_HR_REQ_SUCCESS"
export const CORE_UPDATE_SETTING_HR_REQ_FAILURE = "CORE_UPDATE_SETTING_HR_REQ_FAILURE"


// WEBPACK FOOTER //
// ./src/app/redux/masterDataTypes.js